import { render, staticRenderFns } from "./banner-stars.vue?vue&type=template&id=56207d3c&scoped=true&"
import script from "./banner-stars.vue?vue&type=script&lang=js&"
export * from "./banner-stars.vue?vue&type=script&lang=js&"
import style0 from "./banner-stars.vue?vue&type=style&index=0&id=56207d3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56207d3c",
  null
  
)

export default component.exports